export default __webpack_public_path__ + "static/media/bun-simt.20a843fb.png";